// 获取主题列表
export const apiThemeList = () => {
    return usePost<LyBase.ThemeList>("main/theme/index", {
        site: useSite().value?.site,
    })
}

// 添加主题
export const apiThemeAdd = ({ title }: Pick<LyBase.Theme, "title">) => {
    return usePost("main/theme/add", { title, site: useSite().value?.site })
}

// 删除主题
export const apiThemeDelete = ({ id }: Pick<LyBase.Theme, "id">) => {
    return usePost("main/theme/delete", { id })
}

// 回收站列表
export const apiThemeDelList = () => {
    return usePost<LyBase.ThemeList>("main/theme/dellist", {
        site: useSite().value?.site,
    })
}

// 恢复主题
export const apiThemeUnDelete = ({ id }: Pick<LyBase.Theme, "id">) => {
    return usePost("main/theme/undel", { id })
}

// 删除主题-强删
export const apiThemeForceDelete = ({ id }: Pick<LyBase.Theme, "id">) => {
    return usePost("main/theme/dels", { id })
}

// 修改主题名称
export const apiThemeEdit = ({ id, title }: Pick<LyBase.Theme, "title" | "id">) => {
    return usePost("main/theme/edit", { id, title })
}

// 启用主题
export const apiThemeEnable = ({ id }: Pick<LyBase.Theme, "id">) => {
    return usePost("main/theme/enable", { id })
}

// 复制主题
export const apiThemeCopy = ({ id, title }: Pick<LyBase.Theme, "title" | "id">) => {
    return usePost("main/theme/copy", { id, title })
}
